import React from 'react';

import { ToggleSelector } from '../Common';
import MostPlayedArchive from './MostPlayedArchive';
import Hottest100Archive from './Hottest100Archive';

import { RegisterPageHit } from '../../services/googleAnalyticsHelper';
import { Navigate, useParams } from 'react-router-dom';

const types = ["most-played", "hottest-100"];

const ArchiveSwitcher = () => {

  let { type } = useParams();
  RegisterPageHit(`/archives/${type}`, `archive-${type}`);

  return (
    <div>
      <ToggleSelector toggleItems={["most played", "hottest 100"]} 
      className="toggle-selector archive-toggle" value={type} />
      {type === "most-played" && <MostPlayedArchive />}
      {type === "hottest-100" && <Hottest100Archive />}
      {!types.includes(type) && <Navigate replace to="/404" />}
    </div>

  )
};

export default ArchiveSwitcher;